import Layout from '@/layout'

const route = {
  path: '/retransmissionStrategy',
  component: Layout,
  redirect: '/retransmissionStrategy/index',
  alwaysShow: true, // will always show the root menu
  name: 'retransmissionStrategy',
  meta: {
    title: '回传策略',
    icon: 'RPM',
    roles: [
      'return_ploy_management'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/returnPolicyList/index',
      component: () => import('@/views/returnPolicyList/index.vue'),
      name: 'returnPolicyList',
      meta: {
        title: '回传策略列表',
        icon: 'component',
        roles: [
          'py_callback.index'
        ]
      }
    },
    {
      path: '/returnPolicyList/baiduBackhaul/index',
      component: () => import('@/views/returnPolicyList/BaiduBackhaul/index.vue'),
      name: 'baiduBackhaul',
      meta: {
        title: '百度回传策略列表',
        icon: 'component',
        roles: [
          'py_callback.index'
        ]
      }
    }
  ]
}

export default route
